import { Box, styled } from "@mui/material";

export const MobilePlaceholderWrapper = styled(Box)({
    height: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0e0e0e',
    color: '#fff',
    textAlign: 'center',
});